/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Landing_Finalcta_MicrocopyInputs */

const tr_landing_finalcta_microcopy = /** @type {(inputs: Landing_Finalcta_MicrocopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} gün ücretsiz deneyin · Kredi kartı gerekmez · İstediğiniz zaman iptal edin`)
};

const en_landing_finalcta_microcopy = /** @type {(inputs: Landing_Finalcta_MicrocopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days}-day free trial · No credit card required · Cancel anytime`)
};

const de_landing_finalcta_microcopy = /** @type {(inputs: Landing_Finalcta_MicrocopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage kostenlos testen · Keine Kreditkarte nötig · Jederzeit kündbar`)
};

const ru_landing_finalcta_microcopy = /** @type {(inputs: Landing_Finalcta_MicrocopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} дней бесплатно · Банковская карта не нужна · Отмена в любой момент`)
};

/**
* | output |
* | --- |
* | "{days}-day free trial · No credit card required · Cancel anytime" |
*
* @param {Landing_Finalcta_MicrocopyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_microcopy = /** @type {((inputs: Landing_Finalcta_MicrocopyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_MicrocopyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_microcopy(inputs)
	if (locale === "de") return de_landing_finalcta_microcopy(inputs)
	if (locale === "ru") return ru_landing_finalcta_microcopy(inputs)
	return tr_landing_finalcta_microcopy(inputs)
});